// @flow

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import getNextParam from "./util/utils";
import "./index.css";
import "./polyfill";
import App from "./App";

const renderPage = () => {
  const rootElement = document.getElementById("root");
  if (rootElement instanceof Element) {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      rootElement
    );
  }
};

(() => {
  // check to see if the user is already authenticated
  fetch(`/auth/api/v1/authorize`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    method: "POST"
  })
    .then(d => {
      if (!d.redirected) {
        // redirected to login
        window.location.href = getNextParam() || "/";
      } else {
        renderPage();
      }
    })
    .catch(() => {
      renderPage();
    });
})();
